<template>
  <v-container>
    <avs-backButton
      v-if="!inDialog"
      backTo="Customers"
    />
    <AvsSteppers
      :value="tab"
      @change="v => (tab = v)"
    >
      <template v-slot:headers>
        <AvsStep
          step="1"
          :rules="[() => isFormValid.informations]"
        >
          {{ $t("commons.informations") }}
          <small v-show="!isFormValid.informations">{{ $t("commons.validation_issues") }}</small>
        </AvsStep>
      </template>
      <template v-slot:items>
        <v-stepper-content step="1">
          <v-form
            ref="form-informations"
            v-model="isFormValid.informations"
            class="pt-2 mb-5"
            lazy-validation
          >
            <v-row>
              <v-col class="md-6">
                <v-text-field
                  v-model="staff.first_name"
                  :rules="isDisable ? [] : rules.first_name"
                  :disabled="isDisable"
                  auto-grow
                  clearable
                  dense
                  outlined
                  :label="$t('Nom')"
                />
              </v-col>
              <v-col class="md-6">
                <v-text-field
                  v-model="staff.last_name"
                  :rules="isDisable ? [] : rules.last_name"
                  :disabled="isDisable"
                  auto-grow
                  clearable
                  dense
                  outlined
                  :label="$t('Prenom')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="md-6">
                <v-text-field
                  v-model="staff.phone_number"
                  :rules="isDisable ? [] : rules.phone_number"
                  :disabled="isDisable"
                  auto-grow
                  clearable
                  dense
                  outlined
                  :label="$t('N° Téléphone')"
                />
              </v-col>
              <v-col class="md-6">
                <v-text-field
                  v-model="staff.email"
                  :disabled="isDisable"
                  auto-grow
                  clearable
                  dense
                  outlined
                  :label="$t('Email')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="md-6">
                <v-text-field
                  v-model="staff.part_number"
                  :rules="isDisable ? [] : rules.part_number"
                  :disabled="isDisable"
                  auto-grow
                  clearable
                  dense
                  outlined
                  :label="$t('N° Pièce')"
                />
              </v-col>
              <v-col class="md-6">
                <v-text-field
                  v-model="staff.position"
                  :rules="isDisable ? [] : rules.position"
                  :disabled="isDisable"
                  auto-grow
                  clearable
                  dense
                  outlined
                  :label="$t('Fonction')"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="md-12">
                <v-row>
                  <v-col class="md-9">
                    <v-file-input
                      v-model="carteGriseFile"
                      :rules="carteGriseRules"
                      :disabled="isDisable"
                      clearable
                      dense
                      outlined
                      show-size
                      accept=".pdf,.jpg,.jpeg,.png"
                      :label="$t('Pièce jointe')"
                      @change="handleCarteGriseUpload"
                    />
                  </v-col>

                  <v-col
                    class="md-3"
                    v-if="carteGriseBase64"
                  >
                    <!-- nouveau : prévisualisation / téléchargement si base64 existant -->
                    <div
                      v-if="carteGriseBase64"
                      class="mt-2"
                    >
                      <v-btn
                        text
                        small
                        @click="openCarteGrise"
                      >
                        <v-icon left>mdi-file-document</v-icon>
                        {{ $t("Voir la piece") }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-col
              cols="12"
              class="pt-0 d-flex justify-center"
            >
            </v-col>
          </v-form>
        </v-stepper-content>
      </template>
      <v-spacer></v-spacer>
      <template v-slot:actions>
        <v-card-actions class="mr-4 justify-end">
          <avs-saveButton @click="save" />
        </v-card-actions>
      </template>
    </AvsSteppers>

    <avs-CloseDialog
      v-model="closeDialogIsOpen"
      @cancel="handleCancel"
      @confirm="handleConfirm"
    />
  </v-container>
</template>

<script>
import _ from "lodash"
const noop = () => undefined
import { CustomerService } from "@/services"
import { mkCustomer } from "@/utils/datamodels"

import { required } from "@/utils/validator"

export default {
  name: "CustomerCreateUpdate",
  components: {
    AvsStep: () => import("@/components/generics/general/AvsStep.vue"),
    AvsSteppers: () => import("@/components/generics/general/AvsSteppers.vue")
  },
  props: {
    inDialog: {
      type: Boolean,
      default: false
    },
    inDialogParams: {
      type: Object,
      default: () => {}
    }
  },
  data: function () {
    return {
      staffRef: null,
      selectedBrand: null,
      selectedModel: null,
      carteGriseFile: null, // Pour le fichier File
      carteGriseBase64: null,
      models: [],
      products: [],
      departments: [],
      staff: mkCustomer(),
      tab: this.$route.params.tab ? this.$route.params.tab : 1,
      nextLabel: this.$t("commons.next"),
      loading: false,
      step: -1,
      minReportDate: null,
      rules: {
        first_name: [required],
        last_name: [required],
        image: [],
        part_number: [],
        email: [],
        phone_number: [required],
        position: []
      },
      isFormValid: {
        informations: false,
        budgeet: false,
        causeAndResolution: false
      },
      validateRequest: {
        budgeet: 0
      },
      isDisable: false,
      isClosed: false,
      closeDialogIsOpen: false,
      users: []
    }
  },
  created() {
    this.fetchCustomer()
  },
  methods: {
    openCarteGrise() {
      const win = window.open()
      win.document.write(
        `<iframe src="${this.carteGriseBase64}" frameborder="0" style="width:100%;height:100%;"></iframe>`
      )
    },
    enforcePhoneFormat() {
      if (!this.staff.driver_phone_number.startsWith("+225")) {
        this.staff.driver_phone_number =
          "+225" + this.staff.driver_phone_number.replace(/^(\+225)?/, "")
      }
    },
    save() {
      this.$refs["form-informations"].validate()
      this.$nextTick(() => {
        if (this.isFormValid.informations)
          if (this.staffExists) {
            this.updateCustomer()
          } else {
            this.createCustomer()
          }
        else {
          this.tab = 1
          const message = this.$t("messages.warning.all_required_info")
          this.send(message, "warning")
        }
      })
    },
    handleCarteGriseUpload(file) {
      if (!file) {
        this.carteGriseBase64 = null
        this.staff.carte_grise = null
        return
      }

      const reader = new FileReader()
      reader.onload = () => {
        this.carteGriseBase64 = reader.result // On stocke le base64
        this.staff.carte_grise = this.carteGriseBase64 // On met le base64 dans l'objet envoyé à l'API
      }
      reader.readAsDataURL(file)
    },
    tabIncrement() {
      return this.tab < 4 ? this.tab++ : this.$router.push({ name: "Customers" })
    },
    handleClose() {
      return this.$router.push({ name: "Customers" })
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    },
    getCustomer(id) {
      if (id) {
        let t = this
        CustomerService.get(this, null, id).then(r => {
          t.staff = r
          // Pré-remplir la marque et le modèle
          t.staffRef = _.cloneDeep(t.staff)
          this.carteGriseBase64 = r.carte_grise
        })
      }
    },
    createCustomer() {
      let tmp = _.cloneDeep(this.staff)
      tmp.model = this.selectedModel
      tmp.make = this.selectedBrand
      this.loading = true
      CustomerService.create(this, this.project.id, tmp)
        .then(response => {
          this.staff = response
          this.staffRef = _.cloneDeep(response)
          this.send(
            this.$t("messages.success.saved", {
              entity: "client"
            }),
            "success"
          )
          this.$router.push({ name: "Customers" })
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          } else {
            let message = ""
            for (const e in err.response.data) {
              message += "- " + e + " : " + err.response.data[e] + "\n"
            }
            this.$store.commit("app/message", {
              msg: message,
              color: "error"
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateCustomer() {
      const requests = []
      //  Delete pictures (has deleted==true)

      if (!_.isEqual(_.omit(this.staff), _.omit(this.staffRef))) {
        requests.push(CustomerService.update(this, this.staff.id, _.omit(this.staff)))
      }
      if (requests.length > 0) {
        this.loading = true
        Promise.all(requests)
          .then(() => {
            this.send(
              this.$t("messages.success.updated", {
                entity: this.$tc("categories.staff.name", 1)
              }),
              "success"
            )
            this.$router.push({ name: "Customers" })
          })
          .catch(err => {
            let message = ""
            for (const e in err.response.data) {
              message += "- " + e + " : " + err.response.data[e] + "\n"
            }
            this.send(message, "error")
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.send(this.$t("messages.success.no_updated"), "info")
      }
    },
    fetchCustomer() {
      // Load Customer
      this.getCustomer(this.id)
    },
    handleError(msg) {
      // Handle message display
      this.$store.commit("app/message", { msg, color: "error" })
    },
    handleSign() {
      // Handle message display
      this.isDisable = true
    },
    handleSuccess(isSaved, nextTab, postProcess = noop, message = null) {
      // Handle message display
      const msg_success = message ? message : this.$t("messages.success.operation")
      const data = isSaved
        ? { msg: msg_success, color: "success" }
        : { msg: this.$t("messages.success.no_updated"), color: "info" }
      this.$store.commit("app/message", data)

      // Handle next display
      this.tab = nextTab

      // Postprocess
      postProcess()
    },
    handleConfirm() {
      CustomerService.close(this, this.staff.id)
        .then(r => {
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.closed", {
              entity: this.$tc("categories.staff.name", 1)
            }),
            color: "success"
          })
          this.closeDialogIsOpen = false
          this.isClosed = true
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
      this.closeDialogIsOpen = false
    },
    handleCancel() {
      this.closeDialogIsOpen = false
    }
  },
  watch: {
    tab(newValue, oldValue) {
      if (oldValue === 1) {
        this.save()
      }
    }
  },
  computed: {
    carteGriseRules() {
      // si déjà une carte grise chargée, pas d'obligation
      if (this.isDisable) return []
      return this.carteGriseBase64 ? [] : this.rules.image
    },
    id() {
      return this.inDialog ? this.inDialogParams?.id : this.$route.params.id || null
    },
    staffExists() {
      return this.staff.id
    },
    company() {
      return this.$store.state.app.company
    },
    project() {
      return this.$store.state.app.project
    }
  }
}
</script>

<style lang="scss">
.custom-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
}
.stepper-item {
  flex: 1 1 auto;
  overflow-y: auto;
}
.ck.ck-editor__main > .ck-editor__editable {
  height: 130px;
}
.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by {
  display: none !important;
}
.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.ck-editor__editable {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
